module.exports = __webpack_public_path__ + "img/BCH.80eddd1f.svg";